export default __webpack_public_path__ + "static/doctari-group_logo-548e322c244f6d71dceb1e1eb2dfaf38.svg";